import { Megaphone } from 'lucide-react';
import React from 'react';
import Image from 'next/image';
export default function Solution() {
  return (
    // Outer container with background and padding
    <div className="bg-black pb-16 px-4 sm:px-6 lg:px-8">
      {/* Max-width container to center content */}
      <div className="max-w-7xl mx-auto">

        {/* Grid Section */}
        <div className="grid grid-cols-1 md:grid-cols-2">

          {/* Top Content Section (Headline, Subtext) - Moved into grid */}
          <div className="text-center md:col-span-2 border border-white/10 p-8">
            <span className="text-sm font-semibold text-white tracking-wide mb-6 inline-block border border-white/20 rounded-full px-4 py-2 mt-10">
              <span className="inline-flex items-center">
                <Megaphone className="w-4 h-4 mr-2" />
                The solution
              </span>
            </span>
            <h1 className="text-3xl sm:text-5xl lg:text-6xl font-semibold text-white mb-8">
              Saved is your full-time UGC
              <br />
              campaign organizer
            </h1>
            <p className="text-lg sm:text-xl text-white/80 mb-20">
              We scale organic content in 3 steps
            </p>
          </div>

          {/* <div className="bg-black border border-white/10 text-left flex flex-col relative col-span-1">
            <div className="p-10">

            </div>
            <div className="flex-grow"></div>

            <div className="absolute top-0 left-1/2 w-px h-full bg-white/10"></div>
            <div className="absolute top-0 left-2/2 w-px h-full bg-white/10"></div>
            <div className="absolute top-0 left-3/3 w-px h-full bg-white/10"></div>
            <div className="absolute top-0 left-4/4 w-px h-full bg-white/10"></div>
          </div> */}

          <div className="bg-black border border-white/10 text-left flex flex-col">
            <div className="p-10">
              <h3 className="text-5xl font-thin text-white mb-4">You set a budget</h3>
              <p className="text-white/60">
                Monthly Ad Spend that guarantees views. Only pay for performance.
              </p>
            </div>
            <div className="flex-grow"></div>
            <div className="bg-black text-left flex flex-col mt-10">
              <Image src="https://storage.googleapis.com/saved_media_assets/b2b-background.avif" alt="Saved" width={1000} height={1000} className="w-full h-full object-cover" />
            </div>
          </div>

          <div className="bg-black border border-white/10 text-left flex flex-col">
            <div className="p-10">
              <h3 className="text-5xl font-thin text-white mb-4">We source creators</h3>
              <p className="text-white/60">
                Directed through cash incentives and talent agencies. We handle payouts.
              </p>
            </div>
            <div className="flex-grow"></div>
            <div className="bg-black text-left flex flex-col mt-10">
              <Image src="https://storage.googleapis.com/saved_media_assets/creator-background-1.avif" alt="Saved" width={1000} height={1000} className="w-full h-full object-cover" />
            </div>
          </div>

          <div className="bg-black border border-white/10 text-left flex flex-col md:col-span-2 max-h-[500px] overflow-hidden">
            <div className="p-10">
              <h3 className="text-5xl font-thin text-white mb-4">They make UGC 15x faster with Saved</h3>
              <p className="text-white/60">
                Multi-modal highlight detection that clips and edits in real-time. One-click posting.
              </p>
            </div>
            <div className="flex-grow"></div>
            <div className="bg-black text-left flex flex-col mt-10">
              <Image src="https://storage.googleapis.com/saved_media_assets/landing-background.avif" alt="Saved" width={1000} height={1000} className="w-full h-full object-cover" />
            </div>
          </div>

        </div> {/* End Grid Section */}

      </div> {/* End max-width container */}
    </div> // End outer container
  );
}